import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NewFooterComponent } from './new-footer/new-footer.component';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { PipeModule } from '../pages/pipe.module'
import { MatDialogModule } from '@angular/material/dialog';
import { LoginModal } from '../header/header.component'
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BlockScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { CountdownModule } from 'ngx-countdown';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { MyJsonLdComponent } from './my-json-ld.component';
//  import { CompassComponent } from '../compass/compass.component';
import { GoogleLoginProvider, SocialAuthServiceConfig } from 'angularx-social-login';

const googleLoginOptions = {
  scope: 'profile email',
  plugin_name:'sample_login' //can be any name
};

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
    return () => overlay.scrollStrategies.block();
}

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatMenuModule,
        PipeModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatSnackBarModule,
        TooltipModule,
        MatTooltipModule,
        NgOptimizedImage,
        CountdownModule,
        MatAutocompleteModule,
        NgxSpinnerModule
    ],
    declarations: [
        LoginModal,
        NewFooterComponent,
        TopBarComponent,
        ConfirmationComponent,
        MyJsonLdComponent,
    ],
    exports: [
        LoginModal,
        NewFooterComponent,
        TopBarComponent,
        ConfirmationComponent,
        MyJsonLdComponent,
        PipeModule,
    ],
    providers: [
          {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '137478054331-ig5rvfk5llgso34nf0sronfh0am1ml5b.apps.googleusercontent.com', 
               googleLoginOptions
            )
          }
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    },
        DatePipe,
        {
            provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
            useFactory: scrollFactory,
            deps: [Overlay],
        },
    ]
})
export class CommonChildComponentsModule { }
